"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var ActivationLogoutButton_1 = __importDefault(require("shared/components/Button/ActivationLogoutButton"));
var HoCs_1 = require("utils/HoCs");
var single_1 = require("utils/selectors/single");
var LivePreview_1 = __importDefault(require("../PreviewSection/LivePreview"));
var Wizard_1 = __importDefault(require("../Wizard"));
var hooks_1 = require("./hooks");
var WelcomeStepsMapper_1 = __importDefault(require("./WelcomeStepsMapper"));
var WizardParts_1 = require("./WizardParts");
var PREFIX = 'AssistedOnboarding';
var classes = {
    previewWrapper: "".concat(PREFIX, "-previewWrapper"),
};
var Wizard = (0, Wizard_1.default)(WizardParts_1.WizardContext, { stepTrackingEvent: 'Activation Step Completed' });
var Root = (0, styles_1.styled)(material_1.Grid)(function (_a) {
    var _b, _c;
    var _d;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.previewWrapper)] = (_c = {
                display: 'flex',
                alignItems: 'center',
                background: (_d = theme.palette.azzurro) === null || _d === void 0 ? void 0 : _d.main,
                overflow: 'hidden',
                paddingLeft: theme.spacing(8)
            },
            _c[theme.breakpoints.up('xl')] = {
                justifyContent: 'center',
                paddingLeft: 0,
            },
            _c[theme.breakpoints.down('md')] = {
                display: 'none',
            },
            _c),
        _b);
});
var voidFn = function () { return undefined; };
var AssistedOnboarding = function () {
    var _a;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var _b = (0, hooks_1.useWizardSettings)(), onEnd = _b.onEnd, addStep = _b.addStep, initialValues = _b.initialValues, initialStep = _b.initialStep, STEPS = _b.steps;
    var history = (0, react_router_1.useHistory)();
    return ((0, jsx_runtime_1.jsx)(Wizard, __assign({ steps: STEPS, initialStep: initialStep, blockBackFromFirst: !((_a = profile.completedOnboardingSteps) === null || _a === void 0 ? void 0 : _a.includes('WELCOME_STEP')), onEnd: onEnd, onNextStep: addStep }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: voidFn, initialValues: initialValues, keepDirtyOnReinitialize: true }, { children: function () { return ((0, jsx_runtime_1.jsxs)(Root, __assign({ container: true, sx: { height: '100%' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, sm: 12, md: 6, item: true }, { children: (0, jsx_runtime_1.jsx)(WelcomeStepsMapper_1.default, {}) })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ md: 6, item: true, className: classes.previewWrapper }, { children: [(0, jsx_runtime_1.jsx)(ActivationLogoutButton_1.default, __assign({ onClick: function () { history.push('/logout'); } }, { children: "logout" })), (0, jsx_runtime_1.jsx)(LivePreview_1.default, {})] }))] }))); } })) })));
};
exports.default = (0, HoCs_1.HasCompanyHoC)(AssistedOnboarding);
